import TextField, { TextFieldProps } from '@mui/material/TextField';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Moment } from 'moment';
import { ReactNode } from 'react';

export type ConvergeDateFieldProps = {
  label: ReactNode;
  value: Date | null | undefined | string | Moment;
  onChange: (newValue: Moment | null) => void;
  clearable?: boolean;
} & Omit<TextFieldProps, 'onChange'>;

export const ConvergeDateField = ({
  label,
  value,
  disabled,
  onChange,
  clearable,
  ...props
}: ConvergeDateFieldProps) => {
  return (
    <DatePicker
      label={label}
      value={value ?? null}
      onChange={onChange}
      disabled={disabled}
      componentsProps={
        clearable
          ? {
              actionBar: {
                actions: ['clear'],
              },
            }
          : undefined
      }
      renderInput={(params) => (
        <TextField
          {...params}
          {...props}
          disabled={disabled}
          sx={{
            '& .MuiInputBase-root': {
              height: '50px',
            },
          }}
        />
      )}
    />
  );
};
